<div class="footer" [class.opened]="footerExpanded">
    <div class="footer-toggle" [class.opened]="footerExpanded" (click)="toggleFooter()"></div>
    <div class="options" [class.closed]="!footerExpanded">
        <div class="option">© 2022 Root n Spot ®</div>
        <div class="option selectable" (click)="openPrivacyDialog()">{{i18n._.PRIVACY_POLICY}}</div>
        <!-- <div class="option selectable" (click)="openTermsDialog()">{{i18n._.TERMS}}</div> -->
    </div>
    <div class="contacts" [class.closed]="!footerExpanded">
        <!-- <span class="label">Email:</span> -->
        <div class="contact">
            <a href="mailto:rootnspot@rootnspot.pt" target="_blank">
                <img class="contact-button" src="../../assets/icons/mail.png"/>
                <span>rootnspot@rootnspot.pt</span>
            </a>
        </div>

        <!-- <span class="label">Telf:</span> -->
        <div class="contact">
            <a href="tel:+351911817397/" target="_blank">
                <img class="contact-button" src="../../assets/icons/phone.png"/>
                <span>+351 911 817 397</span>
            </a>
        </div>
        <div class="notice">
            <span>{{i18n._.NATIONAL_CALL_NOTICE}}</span>
        </div>
    </div>
    <div class="links" [class.closed]="!footerExpanded">
        <a href="https://m.facebook.com/ROOT-N-SPOT-109243077484283/" target="_blank"><img class="link-logo" src="../../assets/links/facebook.png"/></a>
        <a href="https://www.instagram.com/root_n_spot/" target="_blank"><img class="link-logo" src="../../assets/links/instagram.png"/></a>
    </div>
</div>